<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div echarts
  [options]="chartOption"
  [style.width]="width"
  [style.height]="height"
  class="chart"
></div>
